import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useAppDispatch, useAppSelector } from '../hooks';
import { selectEntityState } from '../reducers/entityStatesSlice';
import { actionLevel } from '../actions/ActionLevel';
import { Range } from './Range';
export const EntityLevel = props => {
    var _a, _b, _c, _d;
    const entityState = useAppSelector(selectEntityState(props.entity.id));
    const dispatch = useAppDispatch();
    if (props.entity.title !== 'level' || props.action.title !== 'level') {
        return null;
    }
    const actionType = props.action.type;
    if (actionType.name != 'real')
        return null;
    const min = (_b = (_a = actionType.options) === null || _a === void 0 ? void 0 : _a.min) !== null && _b !== void 0 ? _b : 1;
    const max = (_d = (_c = actionType.options) === null || _c === void 0 ? void 0 : _c.max) !== null && _d !== void 0 ? _d : 100;
    const value = (entityState === null || entityState === void 0 ? void 0 : entityState.value.type) == 'real' ? entityState === null || entityState === void 0 ? void 0 : entityState.value.value : min;
    const percent = Math.round((value - min) / max * 100);
    const onChangeLevelControl = (event) => {
        const val = event.target.value;
        const num = parseFloat(val);
        if (!isNaN(num)) {
            dispatch(actionLevel(props.action.id, num));
        }
    };
    return _jsxs(React.Fragment, { children: ["Ljusstyrka (", percent, "%): ", _jsx(Range, { min: min, max: max, value: value, onChange: onChangeLevelControl })] });
};
